import { enServerErrorMessages, svServerErrorMessages } from './server-error-messages.ts';

export const enMessages = {
	'auth.backTo': 'Back to',
	'auth.completingSignIn': 'Completing sign in...',
	'auth.confirmPassword': 'Confirm new password',
	'auth.email': 'Email address',
	'auth.forgotPassword': 'Forgot password?',
	'auth.goBackTo': 'Go back to',
	'auth.haveAccount': 'Already have an account?',
	'auth.newPassword': 'New password',
	'auth.noAccount': "Don't have an account?",
	'auth.openRecoveryLink': 'Open this page from the recovery link in your email to reset your password.',
	'auth.orContinueWith': 'Or continue with',
	'auth.password': 'Password',
	'auth.passwordMismatch': 'Passwords do not match.',
	'auth.passwordTooShort': 'Password must be at least 8 characters long.',
	'auth.passwordUpdated': 'Password updated. Redirecting to sign in...',
	'auth.recoveryNotReady': 'Recovery session not ready. Please open the reset link from your email again.',
	'auth.resetFailed': 'Unable to reset password. Request a new recovery link and try again.',
	'auth.resetPassword': 'Reset password',
	'auth.resetSent': 'An email has been sent with instructions to reset your password.',
	'auth.resettingPassword': 'Resetting password...',
	'auth.saveNewPassword': 'Save new password',
	'auth.savingNewPassword': 'Saving new password...',
	'auth.signIn': 'Sign in',
	'auth.signInFailed': 'Unable to complete sign in, please try again.',
	'auth.signingIn': 'Signing in...',
	'auth.signingUp': 'Signing up...',
	'auth.signUp': 'Sign up',
	'calendar.help': 'Help',
	'calendar.pickDate': 'Pick a date',
	'calendar.settings': 'Settings',
	'common.close': 'Close',
	'dashboard.activeHoldings': '{count, plural, one {# active holding} other {# active holdings}}',
	'dashboard.addIndexHint': 'Add an index to a watchlist and it will become part of this dashboard context.',
	'dashboard.allLanguages': 'All languages',
	'dashboard.atGlance': 'At a glance',
	'dashboard.atGlanceDescription': 'The strongest move, the softest week, and the loudest watchlist names right now.',
	'dashboard.countryMarket': '{country} market',
	'dashboard.currencyContext': 'Currency context',
	'dashboard.currencyContextDescription':
		'FX pairs connected to the instrument currencies you are most exposed to right now.',
	'dashboard.currentValue': 'Current value',
	'dashboard.dateUnavailable': 'Date unavailable',
	'dashboard.intro':
		'A compact read on how your portfolios and watchlists moved this week, what mattered in the news, and what is worth preparing for next week.',
	'dashboard.language': 'Language',
	'dashboard.newsDescription': 'The latest headlines across the companies you care about.',
	'dashboard.newsThisWeek': 'News this week',
	'dashboard.nextWeek': 'Next week',
	'dashboard.nextWeekDescription': 'Upcoming events worth keeping in mind over the next seven days.',
	'dashboard.nextWeekEvents': 'Next week events',
	'dashboard.noCurrencyExposure': 'No foreign-currency exposure surfaced from your active holdings yet.',
	'dashboard.noHeadlines': 'No tracked headlines landed during the last seven days.',
	'dashboard.noHeadlinesForLanguage':
		'No tracked headlines landed during the last seven days for the selected language.',
	'dashboard.noPortfolios': 'No portfolios found for this account yet.',
	'dashboard.noRegionalBenchmarks': 'No regional benchmark mappings available from your current holdings yet.',
	'dashboard.noUpcomingEvents': 'No upcoming tracked events in the next week.',
	'dashboard.noWatchlistIndices': 'No watchlist indices yet.',
	'dashboard.noWatchlistInstruments': 'No watchlist instruments available yet.',
	'dashboard.openCalendar': 'Open calendar',
	'dashboard.portfolioWeek': 'Portfolio week',
	'dashboard.portfolioWeekDescription': 'How your portfolios have moved over the last seven days.',
	'dashboard.regionalMarkets': 'Regional markets',
	'dashboard.regionalMarketsDescription':
		'Benchmarks tied to the countries where your active holdings are concentrated.',
	'dashboard.seeAllInterestNews': 'See all interest news',
	'dashboard.strongestPortfolio': 'Strongest portfolio',
	'dashboard.thisWeeksNews': "This week's news",
	'dashboard.trackedIndex': 'Tracked index',
	'dashboard.trackedIndices': 'Tracked indices',
	'dashboard.trackedIndicesDescription':
		'Add indices to any watchlist and they show up here alongside your weekly brief.',
	'dashboard.watchlistItems': 'Watchlist items',
	'dashboard.watchlistPulse': 'Watchlist pulse',
	'dashboard.weakestPortfolio': 'Weakest portfolio',
	'dashboard.weeklyBrief': 'Weekly brief',
	'distribution.allHidden': 'All distribution charts are hidden. Enable at least one in Chart settings.',
	'distribution.count': '{count} items',
	'distribution.countPair': '{first} / {second} items',
	'distribution.countries': 'Countries',
	'distribution.currencies': 'Currencies',
	'distribution.geoCurrency': 'Geography & currency',
	'distribution.graphSettings': 'Chart settings',
	'distribution.industries': 'Industries',
	'distribution.noData': 'No distribution data available.',
	'distribution.other': 'Other',
	'distribution.otherAbbreviation': 'O',
	'distribution.positions': 'Positions',
	'distribution.sectors': 'Sectors',
	'distribution.showAll': 'Show all ({count})',
	'distribution.showLess': 'Show less',
	'distribution.title': 'Distribution',
	'distribution.types': 'Types',
	'distribution.unknown': 'Unknown',
	'financials.all': 'All',
	'financials.annual': 'Annual',
	'financials.formatting': 'Change financial data format',
	'financials.hideSelection': 'Hide selection row',
	'financials.quarterly': 'Quarterly',
	'financials.quarters': 'Quarters',
	'financials.showSelection': 'Show selection row',
	'financials.toggleAll': 'Show all periods',
	'financials.toggleQuarterly': 'Show quarterly periods',
	'financials.toggleYearly': 'Show annual periods',
	'financials.view': 'View:',
	'financials.years': 'Years',
	'import.accountOverview': 'Account overview',
	'import.addingTo': 'Adding to',
	'import.allFilesAdded': 'All files added',
	'import.autoDetectionDescription':
		'Upload `Securities Transactions`, `Account Overview`, or both. The system will automatically detect which file type you added.',
	'import.autoDetectionEnabled': 'Auto-detection enabled',
	'import.back': 'Back',
	'import.broker.avanza': 'Swedish online broker',
	'import.broker.degiro': 'European online broker - upload one or both files (auto-detected)',
	'import.broker.montrose': 'Swedish broker',
	'import.broker.nordnet': 'Nordic online broker',
	'import.brokersProgress': '{completed} / {total} brokers',
	'import.buySellOrders': 'Buy/sell orders',
	'import.buySellTrades': 'Buy/sell trades',
	'import.cancel': 'Cancel',
	'import.cashBalances': 'Cash balances',
	'import.cashMovements': 'Cash movements',
	'import.clickBrowse': 'or click to browse',
	'import.complete': 'Complete',
	'import.continue': 'Continue',
	'import.continueToReview': 'Continue to review',
	'import.dividendsFeesDeposits': 'Dividends, fees, deposits',
	'import.dragDropCsv': 'Drag and drop your CSV files here',
	'import.error': 'Import error',
	'import.failedToProcess': 'Failed to process files: {error}',
	'import.file.accountOverview': 'Account overview file',
	'import.file.transactionExport': 'Transaction export (CSV)',
	'import.file.transactions': 'Transactions file',
	'import.filesRequired': '{count, plural, one {# file required} other {# files required}}',
	'import.filesUploaded': '{broker} files uploaded successfully',
	'import.instrumentsNeedReview': '{count} instruments need review',
	'import.instrumentsToReview': 'Instruments to review',
	'import.match.amount': 'Amount',
	'import.match.backToFiles': 'Back to files',
	'import.match.backToOptions': 'Back to options',
	'import.match.date': 'Date',
	'import.match.delisted': 'Delisted',
	'import.match.delistedBankrupt': 'Delisted / bankrupt',
	'import.match.delistedDescription': 'Company no longer exists. Transactions will be tracked without price data.',
	'import.match.description':
		'{count, plural, one {# instrument needs} other {# instruments need}} to be identified. Search for each company to link transactions correctly.',
	'import.match.exchangeTransfer': 'Exchange transfer',
	'import.match.exchangeTransferDescription': 'Company moved to another exchange. Requires manual handling.',
	'import.match.externalSearch': 'External search',
	'import.match.inDatabase': 'In database',
	'import.match.linkedTo': 'Linked to:',
	'import.match.matched': 'Matched',
	'import.match.next': 'Next',
	'import.match.noResults': 'No results found for "{query}"',
	'import.match.previous': 'Previous',
	'import.match.progress': '{resolved} of {total} resolved',
	'import.match.quantity': 'Quantity',
	'import.match.searchAndMatch': 'Search & match',
	'import.match.searchDescription': 'Find this company by ticker symbol or name',
	'import.match.searchHint':
		'Search for the company by its ticker symbol or name. Results from your database are shown first. Select a result to link all {count} transactions to this instrument.',
	'import.match.searchPlaceholder': 'Search by ticker or company name...',
	'import.match.skip': "Skip - Don't import these transactions",
	'import.match.skipped': 'Skipped',
	'import.match.title': 'Match instruments',
	'import.match.totalValue': 'Total value:',
	'import.match.transactions': 'Transactions:',
	'import.match.transfer': 'Transfer',
	'import.match.type': 'Type',
	'import.match.types': 'Types:',
	'import.match.typeToSearch': 'Type to search for instruments...',
	'import.match.viewTransactions': 'View {count, plural, one {# transaction} other {# transactions}}',
	'import.match.yourInstruments': 'Your instruments',
	'import.noTransactionsFound': 'No transactions were found in the uploaded files.',
	'import.processFiles': 'Process files',
	'import.processing': 'Processing...',
	'import.progress': 'Progress:',
	'import.reupload': 'Re-upload',
	'import.review.brokerSources': 'Broker sources',
	'import.review.brokers': 'Brokers',
	'import.review.brokerTransactions': '{broker} transactions',
	'import.review.buySellOrders': 'buy/sell orders',
	'import.review.cashBalance': 'Cash balance',
	'import.review.combinedCash': 'Combined cash position',
	'import.review.connected': 'connected',
	'import.review.conversionsDescription':
		'The following ISIN changes were detected. Transactions with the old ISIN will be excluded from position calculations.',
	'import.review.detectedConversions': 'Detected ISIN conversions',
	'import.review.failedImport': 'Failed to import transactions: {error}',
	'import.review.importing': 'Importing...',
	'import.review.importTransactions': 'Import {count} transactions',
	'import.review.instruments': 'Instruments',
	'import.review.markReviewed': 'Mark as reviewed',
	'import.review.overview': 'Import overview',
	'import.review.reviewAll': 'Review all brokers before importing',
	'import.review.reviewAllDescription': 'Please mark each broker tab as reviewed to continue.',
	'import.review.reviewed': 'Reviewed',
	'import.review.selectAll': 'Select all ({count} transactions)',
	'import.review.selectedCount': '{selected}/{total} selected',
	'import.review.selectedForImport': '{selected} of {total} transactions selected for import',
	'import.review.summaryTab': 'Summary & import',
	'import.review.total': 'Total',
	'import.review.trades': 'Trades',
	'import.review.tradesCount': '{count} trades',
	'import.review.transactions': 'transactions',
	'import.review.transactionsCount': '{count} transactions',
	'import.review.uniqueSecurities': 'unique securities',
	'import.securitiesTransactions': 'Securities transactions',
	'import.selectBroker': 'Select your broker',
	'import.selectBrokerDescription': 'Choose the broker you exported your transaction data from.',
	'import.selectBrokers': 'Select your brokers',
	'import.selectBrokersDescription':
		'Choose one or more brokers to import transactions from. You can review each broker separately before importing.',
	'import.selectedBrokers': '{count, plural, one {# broker selected} other {# brokers selected}}',
	'import.stepBrokers': 'Brokers',
	'import.stepMatch': 'Match',
	'import.stepReview': 'Review',
	'import.stepUpload': 'Upload',
	'import.supportedBrokers': 'Supported brokers: Avanza, Nordnet, Degiro · CSV files only',
	'import.title': 'Import transactions',
	'import.totalTransactions': 'Total transactions',
	'import.transactionsLoaded': '{count} transactions loaded',
	'import.transactionsReady': '{count} transactions loaded and ready for review.',
	'import.type.buy': 'Buy',
	'import.type.deposit': 'Deposit',
	'import.type.dividend': 'Dividend',
	'import.type.dividendTax': 'Dividend tax',
	'import.type.fee': 'Fee',
	'import.type.interest': 'Interest',
	'import.type.other': 'Other',
	'import.type.rights': 'Rights issue',
	'import.type.sell': 'Sell',
	'import.type.stockLending': 'Stock lending',
	'import.type.tax': 'Tax',
	'import.type.transferIn': 'Transfer in',
	'import.type.transferOut': 'Transfer out',
	'import.type.warrant': 'Warrant',
	'import.type.withdrawal': 'Withdrawal',
	'import.unrecognizedFormat': 'Unrecognized format',
	'import.uploadBrokerFiles': 'Upload {broker} files',
	'import.uploadBrokerFilesDescription':
		'Upload your transaction export {count, plural, one {file} other {files}} from {broker}.',
	'import.uploadedFiles': 'Uploaded files ({count}/{total})',
	'import.uploadFiles': 'Upload files',
	'import.uploadFilesDescription': 'Upload transaction files for each broker. Progress is saved as you go.',
	'import.uploadRemaining': 'Upload remaining ({count})',
	'insider.character': 'Character',
	'insider.currency': 'Currency',
	'insider.firstReported': 'First time reported',
	'insider.instrumentName': 'Instrument name',
	'insider.instrumentType': 'Instrument type',
	'insider.issuer': 'Issuer',
	'insider.leadingPosition': 'Person in leading position',
	'insider.marketplace': 'Marketplace',
	'insider.notifier': 'Notifier',
	'insider.position': 'Position',
	'insider.price': 'Price',
	'insider.publicationDate': 'Publication date',
	'insider.shareholderProgram': 'Connected to shareholder program',
	'insider.status': 'Status',
	'insider.transactionDate': 'Transaction date',
	'insider.volume': 'Volume',
	'insider.volumeUnit': 'Volume unit',
	'instrument.averageVolume': 'Average volume: {volume} ({count} {unit})',
	'instrument.basic.enterpriseValue': 'Enterprise value',
	'instrument.basic.lastUpdated': 'Last updated: {date}, source: {source}',
	'instrument.basic.marketCap': 'Market cap',
	'instrument.basic.netDebt': 'Net debt',
	'instrument.basic.shares': 'Shares outstanding',
	'instrument.basic.source': 'Source: {source}',
	'instrument.chartInfo': 'Chart info',
	'instrument.closeReports': 'Close reports panel',
	'instrument.closeReportsOverlay': 'Close reports overlay',
	'instrument.country': 'Country of incorporation',
	'instrument.currency': 'Currency',
	'instrument.exchangeName': 'Exchange name',
	'instrument.high': 'High',
	'instrument.industry': 'Industry',
	'instrument.inPortfolios': 'Instrument found in {count, plural, one {# portfolio} other {# portfolios}}.',
	'instrument.inWatchlists': 'Instrument found in {count, plural, one {# watchlist} other {# watchlists}}.',
	'instrument.latestPrice': 'Latest price',
	'instrument.latestUpdate': 'Latest update',
	'instrument.logo': '{name} logo',
	'instrument.low': 'Low',
	'instrument.next': 'Next instrument for this company: {ticker}',
	'instrument.noDescription': 'No company description is available yet for this instrument.',
	'instrument.noFinancials': 'No financials available for this instrument.',
	'instrument.noInsiderTransactions': 'No insider transactions available for this instrument.',
	'instrument.noNews': 'No news available for this instrument right now.',
	'instrument.noOwnership': 'No ownership data available for this instrument.',
	'instrument.noPortfolios': 'Instrument is not in any of your portfolios.',
	'instrument.noWatchlists': 'Instrument is not in any of your watchlists.',
	'instrument.open': 'Open instrument page',
	'instrument.openCurrencyPair': 'Open currency pair ({ticker})',
	'instrument.openPortfolio': 'Open portfolio',
	'instrument.openReport': 'Open report in a new tab',
	'instrument.openReports': 'Open reports panel',
	'instrument.ownershipTable': 'Ownership table',
	'instrument.previous': 'Previous instrument for this company: {ticker}',
	'instrument.priceChange': 'Price change',
	'instrument.priceChangePercent': 'Price change percent',
	'instrument.published': 'Published {date}',
	'instrument.quoteType': 'Quote type',
	'instrument.report': 'Report',
	'instrument.sector': 'Sector',
	'instrument.snapshot.dayRange': 'Day range',
	'instrument.snapshot.exchange': 'Exchange',
	'instrument.snapshot.latestPrice': 'Latest price',
	'instrument.snapshot.marketCap': 'Market cap',
	'instrument.snapshot.move': 'Move',
	'instrument.snapshot.type': 'Instrument type',
	'instrument.snapshot.volume': 'Volume',
	'instrument.snapshot.weekRange': '52-week range',
	'instrument.tab.financials': 'Financials',
	'instrument.tab.overview': 'Overview',
	'instrument.tab.ownership': 'Ownership',
	'instrument.ticker': 'Ticker',
	'instrument.volume': 'Volume (shares traded)',
	'instrument.website': 'Open company website',
	'instrument.widget.basicValue': 'Key values',
	'instrument.widget.basicValueDescription': 'Market value and capital structure',
	'instrument.widget.calendar': 'Calendar',
	'instrument.widget.calendarDescription': 'Upcoming events tied to the instrument',
	'instrument.widget.chart': 'Price & charts',
	'instrument.widget.chartDescription': 'Primary chart experience with comparisons',
	'instrument.widget.description': 'Overview',
	'instrument.widget.descriptionDescription': 'Company description and classification',
	'instrument.widget.insider': 'Insider transactions',
	'instrument.widget.insiderDescription': 'Latest registered insider activity',
	'instrument.widget.marketSnapshot': 'Market snapshot',
	'instrument.widget.marketSnapshotDescription': 'Quick market snapshot for this instrument',
	'instrument.widget.news': 'News & research',
	'instrument.widget.newsDescription': 'Recent company and market coverage',
	'instrument.widget.notes': 'Notes',
	'instrument.widget.notesDescription': 'Personal notes and research context',
	'instrumentNews.activeItems': '{count, plural, one {# item} other {# items}} from active sources',
	'instrumentNews.coverageFeed': 'Coverage feed',
	'instrumentNews.empty': 'No news matched the selected sources.',
	'instrumentNews.filters': 'Filters',
	'instrumentNews.sources': 'Sources',
	'instrumentNews.toggleSources': 'Toggle news sources',
	'landing.openApp': 'See Eqity in action →',
	'landing.taglineFirst': 'Stock analysis',
	'landing.taglineLast': 'simple.',
	'landing.taglineMiddle': 'made',
	'market.atClose': 'At close',
	'market.dayVolume': 'Day volume (price × today’s volume)',
	'market.latest': 'Latest',
	'market.open': 'Market open',
	'market.price': 'Price',
	'market.priceChange': 'Price change',
	'market.priceChangePercent': 'Price change percent',
	'market.status': 'Market status',
	'market.timestamp': 'Timestamp',
	'nav.appearance': 'Appearance',
	'nav.calendar': 'Calendar',
	'nav.dark': 'Dark',
	'nav.dashboard': 'Dashboard',
	'nav.latestSearches': 'Latest Searches',
	'nav.light': 'Light',
	'nav.navigateTo': 'Navigate to {destination}',
	'nav.navigation': 'Navigation',
	'nav.news': 'News',
	'nav.noResults': 'No results',
	'nav.noResultsFound': 'No results found.',
	'nav.notifications': 'Notifications',
	'nav.popularSearches': 'Popular Searches',
	'nav.portfolios': 'Portfolios',
	'nav.screener': 'Screener',
	'nav.search': 'Search',
	'nav.searchPlaceholder': 'Type a command or search...',
	'nav.searchResults': 'Search Results',
	'nav.searchResultsLoading': 'Search Results ...',
	'nav.system': 'System',
	'nav.theme': 'Theme',
	'nav.unreadNotifications': '{count} unread notifications',
	'nav.user': 'User',
	'nav.watchlists': 'Watchlists',
	'news.all': 'All',
	'news.allCompanies': 'All companies',
	'news.calendarEmpty': 'No calendar events available for the selected scope.',
	'news.clearFilters': 'Clear filters',
	'news.columnFormat': 'Column format',
	'news.company': 'Company',
	'news.date': 'Date',
	'news.description': 'Description',
	'news.display': 'Display',
	'news.displayFormat': 'Display format',
	'news.displayTitle': 'Change news table format',
	'news.empty': 'No {language} news available for the selected scope.',
	'news.english': 'English (EN)',
	'news.eventDate': 'Event date',
	'news.eventDescription': 'Event description',
	'news.filterCompany': 'Filter news by company',
	'news.filterLanguage': 'Filter news language',
	'news.filterText': 'Filter news by text',
	'news.instrumentLink': 'Go to instrument page',
	'news.interest': 'Interest',
	'news.items': '{count, plural, one {# item} other {# items}}',
	'news.language': 'News language',
	'news.languageShort': 'Lang: {language}',
	'news.loadingMore': 'Loading more news...',
	'news.loadingNewer': 'Loading newer events...',
	'news.newsDescription': 'News description',
	'news.noDescription': 'No description',
	'news.noMatchingCompanies': 'No matching companies',
	'news.publicationDate': 'Publication date',
	'news.rowFormat': 'Row format',
	'news.searchCompanies': 'Search companies',
	'news.searchCompaniesPlaceholder': 'Search companies...',
	'news.searchHeadlines': 'Search headlines',
	'news.showAll': 'Show all news',
	'news.showInterest': 'Show news for companies of interest',
	'news.userLanguage': 'User language ({language})',
	'news.viewSelection': 'News page view selection',
	'notifications.action': 'Action',
	'notifications.all': 'All',
	'notifications.calendarEvent': 'Calendar event:',
	'notifications.clear': 'Clear notification',
	'notifications.collapseRow': 'Collapse row',
	'notifications.company': 'Company',
	'notifications.companyAffected': 'Company affected by notification',
	'notifications.confirm': 'Confirm notification',
	'notifications.date': 'Date',
	'notifications.description': 'Description',
	'notifications.eventDate': 'Date of event',
	'notifications.eventDescription': 'Notification event description',
	'notifications.expandRow': 'Expand row',
	'notifications.name': 'Name',
	'notifications.notificationDate': 'Notification date',
	'notifications.notificationType': 'Notification type',
	'notifications.openInstrument': 'Open instrument page',
	'notifications.position': 'Position',
	'notifications.positionSize': 'Position size',
	'notifications.price': 'Price',
	'notifications.seeAll': 'See all notifications',
	'notifications.shortHolder': 'Short holder',
	'notifications.totalShortPosition': 'Total short position',
	'notifications.totalShortPositionHeld': 'Total short position held',
	'notifications.type': 'Type',
	'notifications.unread': 'Unread',
	'notifications.value': 'Value',
	'notifications.volume': 'Volume',
	'portfolio.add': 'Add new portfolio',
	'portfolio.addingTransaction': 'Adding transaction...',
	'portfolio.addTransaction': 'Add transaction',
	'portfolio.apcCurrency': 'Average purchase cost (currency)',
	'portfolio.apcInstrument': 'Average purchase cost (instrument)',
	'portfolio.calendar.empty': 'No upcoming calendar events right now.',
	'portfolio.calendar.more': 'See more calendar events',
	'portfolio.calendar.title': 'Calendar',
	'portfolio.cashFlows.byYear': 'By year',
	'portfolio.cashFlows.deposit': 'Deposit',
	'portfolio.cashFlows.description': 'Deposits and withdrawals over time',
	'portfolio.cashFlows.netTotal': 'Net (total)',
	'portfolio.cashFlows.netYtd': 'Net (YTD)',
	'portfolio.cashFlows.noHistory': 'No cash flow history available yet.',
	'portfolio.cashFlows.noTransactions': 'No deposits or withdrawals recorded yet.',
	'portfolio.cashFlows.portfolio': 'Portfolio',
	'portfolio.cashFlows.withdrawal': 'Withdrawal',
	'portfolio.create.bulkImport': 'Bulk import',
	'portfolio.create.bulkImportDescription': "Import transactions from your broker's CSV export file",
	'portfolio.create.create': 'Create portfolio',
	'portfolio.create.creating': 'Creating...',
	'portfolio.create.currency': 'Display currency',
	'portfolio.create.currencyDescription': 'Currency used to display portfolio values and performance',
	'portfolio.create.currencyPlaceholder': 'Select currency',
	'portfolio.create.details': 'Details',
	'portfolio.create.importMethod': 'Import method',
	'portfolio.create.methodQuestion': 'How would you like to add transactions to your portfolio?',
	'portfolio.create.name': 'Portfolio name',
	'portfolio.create.namePlaceholder': 'e.g., Main Portfolio, Retirement Fund',
	'portfolio.create.startEmpty': 'Start empty',
	'portfolio.create.startEmptyDescription': 'Create an empty portfolio and add transactions manually one at a time',
	'portfolio.create.title': 'Create new portfolio',
	'portfolio.debug.cash': 'Cash',
	'portfolio.debug.checksum': 'Checksum',
	'portfolio.debug.chosenClose': 'Chosen close',
	'portfolio.debug.date': 'Date',
	'portfolio.debug.fxClose': 'FX close',
	'portfolio.debug.instrument': 'Instrument',
	'portfolio.debug.instrumentClose': 'Instrument close',
	'portfolio.debug.instrumentId': 'Instrument {id}',
	'portfolio.debug.localClose': 'Local close',
	'portfolio.debug.next': 'Next',
	'portfolio.debug.noPositions': 'No non-zero positions for this day.',
	'portfolio.debug.page': 'Page {current}/{total}',
	'portfolio.debug.positionValueId': 'Position value ID',
	'portfolio.debug.previous': 'Previous',
	'portfolio.debug.shares': 'Shares',
	'portfolio.debug.showing': 'Showing {start}-{end} of {total}',
	'portfolio.debug.title': 'Debug breakdown',
	'portfolio.debug.toggleHint': 'Toggle in portfolio settings',
	'portfolio.debug.total': 'Total',
	'portfolio.debug.weight': 'Weight',
	'portfolio.dividends.description': 'Overview and recent dividend transactions',
	'portfolio.dividends.dividend': 'Dividend',
	'portfolio.dividends.noHistory': 'No yearly summary available yet.',
	'portfolio.dividends.noTransactions': 'No dividend transactions for active holdings right now.',
	'portfolio.dividends.title': 'Dividends',
	'portfolio.dividends.withholdingTax': 'Withholding tax',
	'portfolio.empty': "You don't have any portfolios yet. Add one above.",
	'portfolio.history.allTime': 'All time',
	'portfolio.history.cash': 'Cash',
	'portfolio.history.cashFlows': 'Cash flows',
	'portfolio.history.change': 'Change (SEK)',
	'portfolio.history.chartPeriod': 'Chart period',
	'portfolio.history.chartSettings': 'Chart settings',
	'portfolio.history.close': 'Close',
	'portfolio.history.enableDebug': 'Enable Debug Breakdown Table in Portfolio Settings for the full daily table.',
	'portfolio.history.excludedCashFlows': '{count} cash flows in other currencies or without dates are excluded',
	'portfolio.history.holdings': 'Holdings (ex cash)',
	'portfolio.history.instrument': 'Instrument',
	'portfolio.history.legacyRow': 'Legacy row detected. Rebuild portfolio values to get full debug breakdown.',
	'portfolio.history.loadingHoldings': 'Loading holdings breakdown...',
	'portfolio.history.loadingShares': 'Loading share history...',
	'portfolio.history.max': 'Max',
	'portfolio.history.maximum': 'maximum',
	'portfolio.history.netDeposits': 'Net deposits (SEK)',
	'portfolio.history.netDepositsShort': 'Net deposits',
	'portfolio.history.noComposition': 'No composition data available for this day.',
	'portfolio.history.noShares': 'No share history data for this range.',
	'portfolio.history.performanceByPeriod': 'Performance by period',
	'portfolio.history.period': 'Period',
	'portfolio.history.rangeReturn': '{period} return',
	'portfolio.history.return': 'Return',
	'portfolio.history.selectInstrument': 'Select instrument',
	'portfolio.history.shares': 'Shares',
	'portfolio.history.sharesCount': '{count} shares',
	'portfolio.history.showPeriod': 'Show {period} period',
	'portfolio.history.total': 'Total',
	'portfolio.history.unknownInstrument': 'Unknown instrument',
	'portfolio.history.value': 'Value',
	'portfolio.navigate': 'Go to portfolio "{name}"',
	'portfolio.news.empty': 'No news for active holdings right now.',
	'portfolio.news.more': 'See more news',
	'portfolio.news.title': 'News',
	'portfolio.noSearchResults': 'No results found.',
	'portfolio.notFound': 'Portfolio not found',
	'portfolio.notFoundDescription': 'This portfolio could not be loaded for the current session.',
	'portfolio.openSettings': 'Open portfolio settings',
	'portfolio.openTable': 'Open portfolio table',
	'portfolio.openTransactions': 'Open portfolio transactions',
	'portfolio.pagination.next': 'Next',
	'portfolio.pagination.page': 'Page {current} of {total}',
	'portfolio.pagination.previous': 'Previous',
	'portfolio.searchHelp': 'Not sure? Search for an instrument',
	'portfolio.searchPlaceholder': 'Search for an instrument...',
	'portfolio.searchResults': 'Search results',
	'portfolio.selectAction': 'Select',
	'portfolio.selectOption': 'Select an option',
	'portfolio.shares': 'Shares',
	'push.active': 'Active',
	'push.allow': 'Allow',
	'push.blocked': 'Notifications are blocked in this browser. Enable them in browser settings before subscribing.',
	'push.checking': 'Checking this device...',
	'push.controller': 'Controller',
	'push.description':
		'Eqity can send optional push notifications about events involving companies and instruments in your portfolios or watchlists.',
	'push.disabled': 'Disabled',
	'push.enabled': 'Enabled',
	'push.endpoint': 'Endpoint',
	'push.inspectFailed': 'Could not inspect this device.',
	'push.iosInstall':
		'On iPhone and iPad, add Eqity to your Home Screen first. Open the installed app, then enable push notifications here.',
	'push.lastEvent': 'Last push event',
	'push.localFailed': 'Could not show local notification.',
	'push.localRequested': 'Asked this browser to show a local service-worker notification.',
	'push.noActiveSubscriptions': 'No active subscriptions were available for this user.',
	'push.noneSeen': 'None seen in this tab',
	'push.noSubscription': 'No browser subscription',
	'push.notifications': 'Push notifications:',
	'push.notRegistered': 'Not registered',
	'push.notSubscribed': 'This device is not subscribed.',
	'push.permission': 'Permission',
	'push.prompt': 'Eqity wants to send you push notifications. Allow this?',
	'push.saveFailed': 'Could not save this push subscription.',
	'push.sendTest': 'Send push test',
	'push.serviceWorker': 'Service worker',
	'push.showLocalTest': 'Show local test',
	'push.subscribed': 'This device is subscribed.',
	'push.testFailed': 'Could not send a test notification.',
	'push.testSent': 'Sent {count, plural, one {# test notification} other {# test notifications}}.',
	'push.triggerBrowserSettings': 'Open browser settings for push notifications',
	'push.unavailable': 'Web Push is not available.',
	'push.unconfigured': 'Web Push is not configured for this environment.',
	'push.unsupported': 'This browser does not support Web Push.',
	'push.updateFailed': 'Could not update push notifications.',
	'push.waiting': 'Waiting for next page load',
	'pushPoc.description': 'Test first-party Web Push without loading the full dashboard.',
	'pushPoc.openSettings': 'Open notification settings',
	'pushPoc.title': 'Push notifications test',
	'reports.availableFiles': '{count, plural, one {# available file} other {# available files}}',
	'reports.closeContent': 'Close {type} content',
	'reports.noContent': 'No content selected',
	'reports.noneAvailable': 'No reports available for this instrument yet.',
	'reports.openContent': 'Open {type} content',
	'reports.title': 'Reports',
	'reports.year': 'Year',
	'settings.alternateRowColors': 'Alternate row colors',
	'settings.alternateRowColorsDescription': 'Apply alternating background colors to table rows',
	'settings.autoHideTypes': 'Auto mode: Types are hidden when the distribution only contains cash plus one other type.',
	'settings.bulkImport': 'Bulk import',
	'settings.bulkImportDescription': 'Import transactions from Avanza, Nordnet, or Degiro CSV exports',
	'settings.cancel': 'Cancel',
	'settings.close': 'Close settings',
	'settings.column.allTimePl': 'All-time P/L',
	'settings.column.averagePurchaseCost': 'Average purchase cost',
	'settings.column.currency': 'Currency',
	'settings.column.general': 'General',
	'settings.column.instrument': 'Instrument',
	'settings.column.latestUpdate': 'Latest update',
	'settings.column.local': 'Local',
	'settings.column.localAbsolute': 'Local absolute',
	'settings.column.localRelative': 'Local relative',
	'settings.column.portfolioShare': 'Portfolio share',
	'settings.column.price': 'Price',
	'settings.column.sek': '[SEK]',
	'settings.column.sekAbsolute': '[SEK] absolute',
	'settings.column.sekRelative': '[SEK] relative',
	'settings.column.shares': 'Shares',
	'settings.column.sizeAbsolute': 'Absolute size',
	'settings.column.ticker': 'Ticker',
	'settings.column.todaysPl': "Today's P/L",
	'settings.column.type': 'Type',
	'settings.dangerZone': 'Danger zone',
	'settings.debugBreakdown': 'Debug breakdown table',
	'settings.debugBreakdownDescription': 'Show or hide the debug table in the portfolio history chart',
	'settings.delete': 'Delete',
	'settings.deleteConfirmation':
		'Are you sure you want to delete "{name}"? All positions, transactions, and historical data will be permanently removed. This action cannot be undone.',
	'settings.deleteDescription': 'Permanently delete this portfolio and all its data',
	'settings.deletePortfolio': 'Delete portfolio',
	'settings.deleting': 'Deleting...',
	'settings.display': 'Display',
	'settings.displayCurrency': 'Display currency',
	'settings.displayCurrencyDescription': 'Currency used to display portfolio values',
	'settings.displayDescription': 'Customize how your portfolio table looks',
	'settings.general': 'General',
	'settings.generalDescription': 'Basic portfolio configuration',
	'settings.graph': 'Chart settings',
	'settings.graphDescription': 'Choose which distribution chart cards are visible',
	'settings.hideEmptyPositions': 'Hide empty positions',
	'settings.hideEmptyPositionsDescription': 'Hide positions with zero shares from the table',
	'settings.import': 'Import',
	'settings.importDescription': 'Bulk import transactions from your broker',
	'settings.importTransactions': 'Import transactions',
	'settings.portfolio.manageFor': 'Manage settings for "{name}"',
	'settings.portfolio.title': 'Portfolio settings',
	'settings.portfolioName': 'Portfolio name',
	'settings.portfolioNamePlaceholder': 'Enter portfolio name',
	'settings.saveChanges': 'Save changes',
	'settings.saving': 'Saving...',
	'settings.selectCurrency': 'Select currency',
	'settings.tableApplied': 'Changes are applied directly in the portfolio table.',
	'settings.tableColumns': 'Table columns',
	'settings.tableColumnsDescription': 'Choose which portfolio table columns to show',
	'settings.visibilityApplied': 'Chart and table visibility updates are applied directly in the current session.',
	'transactions.cash': 'Cash',
	'transactions.cashCurrency': 'Cash currency',
	'transactions.date': 'Date',
	'transactions.filteredCount': '{shown} of {total}',
	'transactions.fxRate': 'FX rate',
	'transactions.instrument': 'Instrument',
	'transactions.instrumentCurrency': 'Instrument currency',
	'transactions.instrumentPrice': 'Instrument price',
	'transactions.next': 'Next',
	'transactions.page': 'Page {current} of {total}',
	'transactions.previous': 'Previous',
	'transactions.reset': 'Reset',
	'transactions.rowsPerPage': 'Rows per page',
	'transactions.search': 'Search transactions',
	'transactions.searchPlaceholder': 'Search transactions...',
	'transactions.shares': 'Shares',
	'transactions.showing': 'Showing {shown} of {total}',
	'transactions.type': 'Type',
	'transactions.value': 'Value',
	'user.account.resetHint': 'To reset your password, use the link below:',
	'user.account.resetPassword': 'Reset password',
	'userNotifications.disableSound': 'Disable notification sound',
	'userNotifications.enableSound': 'Enable notification sound',
	'userNotifications.languageTodo': 'TODO: Notification languages and subscriptions?',
	'userNotifications.open': 'Open notifications',
	'userNotifications.soundTitle': 'Enable or disable notification sound',
	'userNotifications.timeoutTodo': 'TODO: Notification timeout while signed in?',
	'userSettings.accessibility': 'Accessibility',
	'userSettings.account': 'Account',
	'userSettings.advanced': 'Advanced',
	'userSettings.appearance': 'Appearance',
	'userSettings.appSection': 'App settings',
	'userSettings.navigateTo': 'Open {destination} settings',
	'userSettings.notifications': 'Notifications',
	'userSettings.privacy': 'Privacy & safety',
	'userSettings.profile': 'Profile',
	'userSettings.signOut': 'Sign out',
	'userSettings.userSection': 'User settings',
	'watchlist.add': 'Add new watchlist',
	'watchlist.addInstrument': 'Add instrument to watchlist',
	'watchlist.cancelInstrument': 'Cancel',
	'watchlist.closeNew': 'Close new watchlist',
	'watchlist.closeSettings': 'Close settings',
	'watchlist.confirmInstrument': 'Add instrument',
	'watchlist.confirmNew': 'Confirm new watchlist',
	'watchlist.delete': 'Delete',
	'watchlist.deleteConfirm':
		'Are you sure you want to delete "{name}"? All associated data will be permanently removed. This action cannot be undone.',
	'watchlist.deleteTitle': 'Delete watchlist',
	'watchlist.empty': "You don't have any watchlists yet. Add one above.",
	'watchlist.instrumentCurrency': '{exchange} - {source}. Currency: {currency}',
	'watchlist.name': 'Name',
	'watchlist.nameRequired': 'Name cannot be empty',
	'watchlist.navigate': 'Go to watchlist "{name}"',
	'watchlist.newName': 'New watchlist name',
	'watchlist.news': 'News',
	'watchlist.openNews': 'Open watchlist news',
	'watchlist.openOverview': 'Open watchlist overview',
	'watchlist.openSettings': 'Open watchlist settings',
	'watchlist.overview': 'Overview',
	'watchlist.removeInstrument': 'Remove instrument from watchlist',
	'watchlist.save': 'Save',
	'watchlist.settings': 'Watchlist settings',
	...enServerErrorMessages,
} as const;

export type MessageId = keyof typeof enMessages;

export const svMessages: Record<MessageId, string> = {
	'auth.backTo': 'Tillbaka till',
	'auth.completingSignIn': 'Slutför inloggning...',
	'auth.confirmPassword': 'Bekräfta nytt lösenord',
	'auth.email': 'E-postadress',
	'auth.forgotPassword': 'Glömt lösenordet?',
	'auth.goBackTo': 'Gå tillbaka till',
	'auth.haveAccount': 'Har du redan ett konto?',
	'auth.newPassword': 'Nytt lösenord',
	'auth.noAccount': 'Har du inget konto?',
	'auth.openRecoveryLink': 'Öppna sidan via återställningslänken i mejlet för att återställa ditt lösenord.',
	'auth.orContinueWith': 'Eller fortsätt med',
	'auth.password': 'Lösenord',
	'auth.passwordMismatch': 'Lösenorden stämmer inte överens.',
	'auth.passwordTooShort': 'Lösenordet måste vara minst 8 tecken långt.',
	'auth.passwordUpdated': 'Lösenordet har uppdaterats. Du skickas vidare till inloggningen...',
	'auth.recoveryNotReady': 'Återställningssessionen är inte klar. Öppna länken i mejlet igen.',
	'auth.resetFailed': 'Lösenordet kunde inte återställas. Begär en ny länk och försök igen.',
	'auth.resetPassword': 'Återställ lösenord',
	'auth.resetSent': 'Ett mejl med instruktioner för att återställa lösenordet har skickats.',
	'auth.resettingPassword': 'Återställer lösenord...',
	'auth.saveNewPassword': 'Spara nytt lösenord',
	'auth.savingNewPassword': 'Sparar nytt lösenord...',
	'auth.signIn': 'Logga in',
	'auth.signInFailed': 'Inloggningen kunde inte slutföras. Försök igen.',
	'auth.signingIn': 'Loggar in...',
	'auth.signingUp': 'Registrerar...',
	'auth.signUp': 'Registrera dig',
	'calendar.help': 'Hjälp',
	'calendar.pickDate': 'Välj datum',
	'calendar.settings': 'Inställningar',
	'common.close': 'Stäng',
	'dashboard.activeHoldings': '{count, plural, one {# aktivt innehav} other {# aktiva innehav}}',
	'dashboard.addIndexHint': 'Lägg till ett index i en bevakningslista så visas det här.',
	'dashboard.allLanguages': 'Alla språk',
	'dashboard.atGlance': 'I korthet',
	'dashboard.atGlanceDescription':
		'Starkaste uppgången, svagaste veckan och de mest rörliga bevakade instrumenten just nu.',
	'dashboard.countryMarket': '{country} marknad',
	'dashboard.currencyContext': 'Valutaläge',
	'dashboard.currencyContextDescription': 'Valutapar kopplade till de valutor du har störst exponering mot just nu.',
	'dashboard.currentValue': 'Nuvarande värde',
	'dashboard.dateUnavailable': 'Datum saknas',
	'dashboard.intro':
		'En snabb överblick över hur dina portföljer och bevakningslistor utvecklades i veckan, vilka nyheter som spelade roll och vad som väntar nästa vecka.',
	'dashboard.language': 'Språk',
	'dashboard.newsDescription': 'De senaste rubrikerna från bolagen du följer.',
	'dashboard.newsThisWeek': 'Nyheter denna vecka',
	'dashboard.nextWeek': 'Nästa vecka',
	'dashboard.nextWeekDescription': 'Kommande händelser att hålla koll på de närmaste sju dagarna.',
	'dashboard.nextWeekEvents': 'Händelser nästa vecka',
	'dashboard.noCurrencyExposure': 'Ingen exponering mot utländska valutor hittades bland dina aktiva innehav ännu.',
	'dashboard.noHeadlines': 'Inga nyheter från bevakade bolag de senaste sju dagarna.',
	'dashboard.noHeadlinesForLanguage': 'Inga nyheter från bevakade bolag de senaste sju dagarna på det valda språket.',
	'dashboard.noPortfolios': 'Inga portföljer hittades för kontot ännu.',
	'dashboard.noRegionalBenchmarks': 'Inga regionala jämförelseindex finns för dina nuvarande innehav ännu.',
	'dashboard.noUpcomingEvents': 'Inga kommande händelser från bevakade bolag nästa vecka.',
	'dashboard.noWatchlistIndices': 'Inga bevakade index ännu.',
	'dashboard.noWatchlistInstruments': 'Inga instrument i bevakningslistorna ännu.',
	'dashboard.openCalendar': 'Öppna kalendern',
	'dashboard.portfolioWeek': 'Portföljer senaste veckan',
	'dashboard.portfolioWeekDescription': 'Så har dina portföljer utvecklats de senaste sju dagarna.',
	'dashboard.regionalMarkets': 'Regionala marknader',
	'dashboard.regionalMarketsDescription': 'Index för länderna där dina aktiva innehav är koncentrerade.',
	'dashboard.seeAllInterestNews': 'Visa alla relevanta nyheter',
	'dashboard.strongestPortfolio': 'Starkaste portfölj',
	'dashboard.thisWeeksNews': 'Veckans nyheter',
	'dashboard.trackedIndex': 'Bevakat index',
	'dashboard.trackedIndices': 'Bevakade index',
	'dashboard.trackedIndicesDescription':
		'Lägg till index i en bevakningslista så visas de här tillsammans med veckoöversikten.',
	'dashboard.watchlistItems': 'Bevakade instrument',
	'dashboard.watchlistPulse': 'Bevakningslistornas rörelser',
	'dashboard.weakestPortfolio': 'Svagaste portfölj',
	'dashboard.weeklyBrief': 'Veckoöversikt',
	'distribution.allHidden': 'Alla fördelningsgrafer är dolda. Aktivera minst en i Grafinställningar.',
	'distribution.count': '{count} st',
	'distribution.countPair': '{first} / {second} st',
	'distribution.countries': 'Länder',
	'distribution.currencies': 'Valutor',
	'distribution.geoCurrency': 'Geografi och valuta',
	'distribution.graphSettings': 'Grafinställningar',
	'distribution.industries': 'Branscher',
	'distribution.noData': 'Ingen fördelningsdata tillgänglig.',
	'distribution.other': 'Övrigt',
	'distribution.otherAbbreviation': 'Ö',
	'distribution.positions': 'Positioner',
	'distribution.sectors': 'Sektorer',
	'distribution.showAll': 'Visa alla ({count})',
	'distribution.showLess': 'Visa färre',
	'distribution.title': 'Fördelning',
	'distribution.types': 'Typer',
	'distribution.unknown': 'Okänd',
	'financials.all': 'Alla',
	'financials.annual': 'Årsvis',
	'financials.formatting': 'Ändra format för finansiella data',
	'financials.hideSelection': 'Dölj markeringsrad',
	'financials.quarterly': 'Kvartalsvis',
	'financials.quarters': 'Kvartal',
	'financials.showSelection': 'Visa markeringsrad',
	'financials.toggleAll': 'Visa alla perioder',
	'financials.toggleQuarterly': 'Visa kvartalsperioder',
	'financials.toggleYearly': 'Visa årsperioder',
	'financials.view': 'Visa:',
	'financials.years': 'År',
	'import.accountOverview': 'Kontoöversikt',
	'import.addingTo': 'Lägg till i',
	'import.allFilesAdded': 'Alla filer tillagda',
	'import.autoDetectionDescription':
		'Ladda upp `Securities Transactions`, `Account Overview` eller båda. Systemet känner automatiskt igen filtypen.',
	'import.autoDetectionEnabled': 'Automatisk identifiering aktiverad',
	'import.back': 'Tillbaka',
	'import.broker.avanza': 'Svensk nätmäklare',
	'import.broker.degiro': 'Europeisk nätmäklare - ladda upp en eller båda filerna (identifieras automatiskt)',
	'import.broker.montrose': 'Svensk mäklare',
	'import.broker.nordnet': 'Nordisk nätmäklare',
	'import.brokersProgress': '{completed} / {total} mäklare',
	'import.buySellOrders': 'Köp- och säljorder',
	'import.buySellTrades': 'Köp- och säljaffärer',
	'import.cancel': 'Avbryt',
	'import.cashBalances': 'Kontosaldon',
	'import.cashMovements': 'Kapitalrörelser',
	'import.clickBrowse': 'eller klicka för att välja filer',
	'import.complete': 'Klart',
	'import.continue': 'Fortsätt',
	'import.continueToReview': 'Fortsätt till granskning',
	'import.dividendsFeesDeposits': 'Utdelningar, avgifter, insättningar',
	'import.dragDropCsv': 'Dra och släpp dina CSV-filer här',
	'import.error': 'Importfel',
	'import.failedToProcess': 'Kunde inte bearbeta filerna: {error}',
	'import.file.accountOverview': 'Kontoöversikt',
	'import.file.transactionExport': 'Transaktionsexport (CSV)',
	'import.file.transactions': 'Transaktionsfil',
	'import.filesRequired': '{count, plural, one {# fil krävs} other {# filer krävs}}',
	'import.filesUploaded': 'Filerna från {broker} har laddats upp',
	'import.instrumentsNeedReview': '{count} instrument behöver granskas',
	'import.instrumentsToReview': 'Instrument att granska',
	'import.match.amount': 'Belopp',
	'import.match.backToFiles': 'Tillbaka till filer',
	'import.match.backToOptions': 'Tillbaka till alternativ',
	'import.match.date': 'Datum',
	'import.match.delisted': 'Avnoterad',
	'import.match.delistedBankrupt': 'Avnoterad / konkurs',
	'import.match.delistedDescription': 'Bolaget finns inte längre. Transaktionerna spåras utan prisdata.',
	'import.match.description':
		'{count, plural, one {# instrument behöver} other {# instrument behöver}} identifieras. Sök efter varje bolag för att länka transaktionerna korrekt.',
	'import.match.exchangeTransfer': 'Byte av handelsplats',
	'import.match.exchangeTransferDescription':
		'Bolaget har flyttat till en annan handelsplats. Kräver manuell hantering.',
	'import.match.externalSearch': 'Extern sökning',
	'import.match.inDatabase': 'I databasen',
	'import.match.linkedTo': 'Länkad till:',
	'import.match.matched': 'Matchad',
	'import.match.next': 'Nästa',
	'import.match.noResults': 'Inga resultat för "{query}"',
	'import.match.previous': 'Föregående',
	'import.match.progress': '{resolved} av {total} lösta',
	'import.match.quantity': 'Antal',
	'import.match.searchAndMatch': 'Sök och matcha',
	'import.match.searchDescription': 'Hitta bolaget med ticker eller namn',
	'import.match.searchHint':
		'Sök efter bolaget med ticker eller namn. Resultat från din databas visas först. Välj ett resultat för att länka alla {count} transaktioner till instrumentet.',
	'import.match.searchPlaceholder': 'Sök på ticker eller bolagsnamn...',
	'import.match.skip': 'Hoppa över - importera inte dessa transaktioner',
	'import.match.skipped': 'Hoppad över',
	'import.match.title': 'Matcha instrument',
	'import.match.totalValue': 'Totalt värde:',
	'import.match.transactions': 'Transaktioner:',
	'import.match.transfer': 'Flyttad',
	'import.match.type': 'Typ',
	'import.match.types': 'Typer:',
	'import.match.typeToSearch': 'Skriv för att söka efter instrument...',
	'import.match.viewTransactions': 'Visa {count, plural, one {# transaktion} other {# transaktioner}}',
	'import.match.yourInstruments': 'Dina instrument',
	'import.noTransactionsFound': 'Inga transaktioner hittades i de uppladdade filerna.',
	'import.processFiles': 'Bearbeta filer',
	'import.processing': 'Bearbetar...',
	'import.progress': 'Förlopp:',
	'import.reupload': 'Ladda upp igen',
	'import.review.brokerSources': 'Mäklarkällor',
	'import.review.brokers': 'Mäklare',
	'import.review.brokerTransactions': 'Transaktioner från {broker}',
	'import.review.buySellOrders': 'köp- och säljorder',
	'import.review.cashBalance': 'Kontosaldo',
	'import.review.combinedCash': 'Samlad likvidposition',
	'import.review.connected': 'anslutna',
	'import.review.conversionsDescription':
		'Följande ISIN-byten hittades. Transaktioner med det gamla ISIN-numret tas inte med i positionsberäkningarna.',
	'import.review.detectedConversions': 'Identifierade ISIN-byten',
	'import.review.failedImport': 'Kunde inte importera transaktioner: {error}',
	'import.review.importing': 'Importerar...',
	'import.review.importTransactions': 'Importera {count} transaktioner',
	'import.review.instruments': 'Instrument',
	'import.review.markReviewed': 'Markera som granskad',
	'import.review.overview': 'Importöversikt',
	'import.review.reviewAll': 'Granska alla mäklare före import',
	'import.review.reviewAllDescription': 'Markera varje mäklarflik som granskad för att fortsätta.',
	'import.review.reviewed': 'Granskad',
	'import.review.selectAll': 'Välj alla ({count} transaktioner)',
	'import.review.selectedCount': '{selected}/{total} valda',
	'import.review.selectedForImport': '{selected} av {total} transaktioner valda för import',
	'import.review.summaryTab': 'Sammanfattning och import',
	'import.review.total': 'Totalt',
	'import.review.trades': 'Affärer',
	'import.review.tradesCount': '{count} affärer',
	'import.review.transactions': 'transaktioner',
	'import.review.transactionsCount': '{count} transaktioner',
	'import.review.uniqueSecurities': 'unika värdepapper',
	'import.securitiesTransactions': 'Värdepapperstransaktioner',
	'import.selectBroker': 'Välj din mäklare',
	'import.selectBrokerDescription': 'Välj den mäklare som du exporterade dina transaktioner från.',
	'import.selectBrokers': 'Välj dina mäklare',
	'import.selectBrokersDescription':
		'Välj en eller flera mäklare att importera transaktioner från. Du kan granska varje mäklare separat före importen.',
	'import.selectedBrokers': '{count, plural, one {# mäklare vald} other {# mäklare valda}}',
	'import.stepBrokers': 'Mäklare',
	'import.stepMatch': 'Matcha',
	'import.stepReview': 'Granska',
	'import.stepUpload': 'Ladda upp',
	'import.supportedBrokers': 'Mäklare som stöds: Avanza, Nordnet, Degiro · Endast CSV-filer',
	'import.title': 'Importera transaktioner',
	'import.totalTransactions': 'Totalt antal transaktioner',
	'import.transactionsLoaded': '{count} transaktioner inlästa',
	'import.transactionsReady': '{count} transaktioner inlästa och klara för granskning.',
	'import.type.buy': 'Köp',
	'import.type.deposit': 'Insättning',
	'import.type.dividend': 'Utdelning',
	'import.type.dividendTax': 'Utdelningsskatt',
	'import.type.fee': 'Avgift',
	'import.type.interest': 'Ränta',
	'import.type.other': 'Övrigt',
	'import.type.rights': 'Nyemission',
	'import.type.sell': 'Sälj',
	'import.type.stockLending': 'Aktielån',
	'import.type.tax': 'Skatt',
	'import.type.transferIn': 'Överföring in',
	'import.type.transferOut': 'Överföring ut',
	'import.type.warrant': 'Teckningsoption',
	'import.type.withdrawal': 'Uttag',
	'import.unrecognizedFormat': 'Okänt format',
	'import.uploadBrokerFiles': 'Ladda upp filer från {broker}',
	'import.uploadBrokerFilesDescription':
		'Ladda upp {count, plural, one {din transaktionsfil} other {dina transaktionsfiler}} från {broker}.',
	'import.uploadedFiles': 'Uppladdade filer ({count}/{total})',
	'import.uploadFiles': 'Ladda upp filer',
	'import.uploadFilesDescription': 'Ladda upp transaktionsfiler för varje mäklare. Framstegen sparas löpande.',
	'import.uploadRemaining': 'Ladda upp återstående ({count})',
	'insider.character': 'Karaktär',
	'insider.currency': 'Valuta',
	'insider.firstReported': 'Första anmälan',
	'insider.instrumentName': 'Instrumentnamn',
	'insider.instrumentType': 'Instrumenttyp',
	'insider.issuer': 'Emittent',
	'insider.leadingPosition': 'Person i ledande ställning',
	'insider.marketplace': 'Marknadsplats',
	'insider.notifier': 'Anmälare',
	'insider.position': 'Befattning',
	'insider.price': 'Pris',
	'insider.publicationDate': 'Publiceringsdatum',
	'insider.shareholderProgram': 'Kopplad till aktieägarprogram',
	'insider.status': 'Status',
	'insider.transactionDate': 'Transaktionsdatum',
	'insider.volume': 'Volym',
	'insider.volumeUnit': 'Volymenhet',
	'instrument.averageVolume': 'Genomsnittlig volym: {volume} ({count} {unit})',
	'instrument.basic.enterpriseValue': 'Företagsvärde',
	'instrument.basic.lastUpdated': 'Senast uppdaterad: {date}, källa: {source}',
	'instrument.basic.marketCap': 'Börsvärde',
	'instrument.basic.netDebt': 'Nettoskuld',
	'instrument.basic.shares': 'Utestående aktier',
	'instrument.basic.source': 'Källa: {source}',
	'instrument.chartInfo': 'Diagraminformation',
	'instrument.closeReports': 'Stäng rapportpanelen',
	'instrument.closeReportsOverlay': 'Stäng rapportpanelen',
	'instrument.country': 'Registreringsland',
	'instrument.currency': 'Valuta',
	'instrument.exchangeName': 'Handelsplats',
	'instrument.high': 'Högsta',
	'instrument.industry': 'Bransch',
	'instrument.inPortfolios': 'Instrumentet finns i {count, plural, one {# portfölj} other {# portföljer}}.',
	'instrument.inWatchlists':
		'Instrumentet finns i {count, plural, one {# bevakningslista} other {# bevakningslistor}}.',
	'instrument.latestPrice': 'Senaste pris',
	'instrument.latestUpdate': 'Senaste uppdatering',
	'instrument.logo': 'Logotyp för {name}',
	'instrument.low': 'Lägsta',
	'instrument.next': 'Nästa instrument för detta bolag: {ticker}',
	'instrument.noDescription': 'Det finns ännu ingen företagsbeskrivning för detta instrument.',
	'instrument.noFinancials': 'Ingen finansiell information tillgänglig för instrumentet.',
	'instrument.noInsiderTransactions': 'Inga insidertransaktioner tillgängliga för instrumentet.',
	'instrument.noNews': 'Inga nyheter tillgängliga för instrumentet just nu.',
	'instrument.noOwnership': 'Ingen ägarinformation tillgänglig för instrumentet.',
	'instrument.noPortfolios': 'Instrumentet finns inte i någon av dina portföljer.',
	'instrument.noWatchlists': 'Instrumentet finns inte i någon av dina bevakningslistor.',
	'instrument.open': 'Öppna instrumentsidan',
	'instrument.openCurrencyPair': 'Öppna valutapar ({ticker})',
	'instrument.openPortfolio': 'Öppna portfölj',
	'instrument.openReport': 'Öppna rapporten i en ny flik',
	'instrument.openReports': 'Öppna rapportpanelen',
	'instrument.ownershipTable': 'Ägartabell',
	'instrument.previous': 'Föregående instrument för detta bolag: {ticker}',
	'instrument.priceChange': 'Prisförändring',
	'instrument.priceChangePercent': 'Prisförändring i procent',
	'instrument.published': 'Publicerad {date}',
	'instrument.quoteType': 'Instrumenttyp',
	'instrument.report': 'Rapport',
	'instrument.sector': 'Sektor',
	'instrument.snapshot.dayRange': 'Dagens intervall',
	'instrument.snapshot.exchange': 'Handelsplats',
	'instrument.snapshot.latestPrice': 'Senaste pris',
	'instrument.snapshot.marketCap': 'Börsvärde',
	'instrument.snapshot.move': 'Förändring',
	'instrument.snapshot.type': 'Instrumenttyp',
	'instrument.snapshot.volume': 'Volym',
	'instrument.snapshot.weekRange': '52-veckorsintervall',
	'instrument.tab.financials': 'Finansiellt',
	'instrument.tab.overview': 'Översikt',
	'instrument.tab.ownership': 'Ägare',
	'instrument.ticker': 'Ticker',
	'instrument.volume': 'Volym (handlade aktier)',
	'instrument.website': 'Öppna bolagets webbplats',
	'instrument.widget.basicValue': 'Nyckeltal',
	'instrument.widget.basicValueDescription': 'Marknadsvärde och kapitalstruktur',
	'instrument.widget.calendar': 'Kalender',
	'instrument.widget.calendarDescription': 'Kommande händelser för instrumentet',
	'instrument.widget.chart': 'Pris och diagram',
	'instrument.widget.chartDescription': 'Prisdiagram och jämförelser',
	'instrument.widget.description': 'Översikt',
	'instrument.widget.descriptionDescription': 'Företagsbeskrivning och klassificering',
	'instrument.widget.insider': 'Insidertransaktioner',
	'instrument.widget.insiderDescription': 'Senaste registrerade insideraktivitet',
	'instrument.widget.marketSnapshot': 'Marknadsöversikt',
	'instrument.widget.marketSnapshotDescription': 'Snabb marknadsöversikt för instrumentet',
	'instrument.widget.news': 'Nyheter och analys',
	'instrument.widget.newsDescription': 'Senaste rapporteringen om bolaget och marknaden',
	'instrument.widget.notes': 'Anteckningar',
	'instrument.widget.notesDescription': 'Personliga anteckningar och analys',
	'instrumentNews.activeItems': '{count, plural, one {# artikel} other {# artiklar}} från aktiva källor',
	'instrumentNews.coverageFeed': 'Nyhetsflöde',
	'instrumentNews.empty': 'Inga nyheter matchade de valda källorna.',
	'instrumentNews.filters': 'Filter',
	'instrumentNews.sources': 'Källor',
	'instrumentNews.toggleSources': 'Välj nyhetskällor',
	'landing.openApp': 'Upptäck Eqity →',
	'landing.taglineFirst': 'Aktieanalys',
	'landing.taglineLast': 'enkelt sätt.',
	'landing.taglineMiddle': 'på ett',
	'market.atClose': 'Vid stängning',
	'market.dayVolume': 'Dagsvolym (pris × dagens volym)',
	'market.latest': 'Senaste',
	'market.open': 'Marknaden öppen',
	'market.price': 'Pris',
	'market.priceChange': 'Prisförändring',
	'market.priceChangePercent': 'Prisförändring i procent',
	'market.status': 'Marknadsstatus',
	'market.timestamp': 'Tidpunkt',
	'nav.appearance': 'Utseende',
	'nav.calendar': 'Kalender',
	'nav.dark': 'Mörkt',
	'nav.dashboard': 'Översikt',
	'nav.latestSearches': 'Senaste sökningar',
	'nav.light': 'Ljust',
	'nav.navigateTo': 'Gå till {destination}',
	'nav.navigation': 'Navigering',
	'nav.news': 'Nyheter',
	'nav.noResults': 'Inga resultat',
	'nav.noResultsFound': 'Inga resultat hittades.',
	'nav.notifications': 'Notiser',
	'nav.popularSearches': 'Populära sökningar',
	'nav.portfolios': 'Portföljer',
	'nav.screener': 'Aktiefilter',
	'nav.search': 'Sök',
	'nav.searchPlaceholder': 'Skriv ett kommando eller sök...',
	'nav.searchResults': 'Sökresultat',
	'nav.searchResultsLoading': 'Sökresultat ...',
	'nav.system': 'System',
	'nav.theme': 'Tema',
	'nav.unreadNotifications': '{count} olästa notiser',
	'nav.user': 'Användare',
	'nav.watchlists': 'Bevakningslistor',
	'news.all': 'Alla',
	'news.allCompanies': 'Alla bolag',
	'news.calendarEmpty': 'Inga kalenderhändelser för det valda urvalet.',
	'news.clearFilters': 'Rensa filter',
	'news.columnFormat': 'Kolumnformat',
	'news.company': 'Bolag',
	'news.date': 'Datum',
	'news.description': 'Beskrivning',
	'news.display': 'Visning',
	'news.displayFormat': 'Visningsformat',
	'news.displayTitle': 'Ändra nyhetstabellens format',
	'news.empty': 'Inga nyheter på {language} för det valda urvalet.',
	'news.english': 'Engelska (EN)',
	'news.eventDate': 'Händelsedatum',
	'news.eventDescription': 'Händelsebeskrivning',
	'news.filterCompany': 'Filtrera nyheter efter bolag',
	'news.filterLanguage': 'Filtrera nyheter efter språk',
	'news.filterText': 'Filtrera nyheter efter text',
	'news.instrumentLink': 'Gå till instrumentsidan',
	'news.interest': 'Intresse',
	'news.items': '{count, plural, one {# objekt} other {# objekt}}',
	'news.language': 'Nyhetsspråk',
	'news.languageShort': 'Språk: {language}',
	'news.loadingMore': 'Läser in fler nyheter...',
	'news.loadingNewer': 'Läser in nyare händelser...',
	'news.newsDescription': 'Nyhetsbeskrivning',
	'news.noDescription': 'Ingen beskrivning',
	'news.noMatchingCompanies': 'Inga matchande bolag',
	'news.publicationDate': 'Publiceringsdatum',
	'news.rowFormat': 'Radformat',
	'news.searchCompanies': 'Sök bolag',
	'news.searchCompaniesPlaceholder': 'Sök bolag...',
	'news.searchHeadlines': 'Sök rubriker',
	'news.showAll': 'Visa alla nyheter',
	'news.showInterest': 'Visa nyheter för bolag av intresse',
	'news.userLanguage': 'Användarspråk ({language})',
	'news.viewSelection': 'Välj nyhetsvy',
	'notifications.action': 'Åtgärd',
	'notifications.all': 'Alla',
	'notifications.calendarEvent': 'Kalenderhändelse:',
	'notifications.clear': 'Rensa notis',
	'notifications.collapseRow': 'Fäll ihop raden',
	'notifications.company': 'Bolag',
	'notifications.companyAffected': 'Bolag som berörs av notisen',
	'notifications.confirm': 'Bekräfta notis',
	'notifications.date': 'Datum',
	'notifications.description': 'Beskrivning',
	'notifications.eventDate': 'Händelsedatum',
	'notifications.eventDescription': 'Beskrivning av notishändelsen',
	'notifications.expandRow': 'Fäll ut raden',
	'notifications.name': 'Namn',
	'notifications.notificationDate': 'Notisdatum',
	'notifications.notificationType': 'Notistyp',
	'notifications.openInstrument': 'Öppna instrumentsidan',
	'notifications.position': 'Befattning',
	'notifications.positionSize': 'Positionsstorlek',
	'notifications.price': 'Pris',
	'notifications.seeAll': 'Visa alla notiser',
	'notifications.shortHolder': 'Blankare',
	'notifications.totalShortPosition': 'Total blankad position',
	'notifications.totalShortPositionHeld': 'Total blankad position',
	'notifications.type': 'Typ',
	'notifications.unread': 'Olästa',
	'notifications.value': 'Värde',
	'notifications.volume': 'Volym',
	'portfolio.add': 'Lägg till ny portfölj',
	'portfolio.addingTransaction': 'Lägger till transaktion...',
	'portfolio.addTransaction': 'Lägg till transaktion',
	'portfolio.apcCurrency': 'Genomsnittligt anskaffningsvärde (valuta)',
	'portfolio.apcInstrument': 'Genomsnittligt anskaffningsvärde (instrument)',
	'portfolio.calendar.empty': 'Inga kommande kalenderhändelser just nu.',
	'portfolio.calendar.more': 'Visa fler kalenderhändelser',
	'portfolio.calendar.title': 'Kalender',
	'portfolio.cashFlows.byYear': 'Per år',
	'portfolio.cashFlows.deposit': 'Insättning',
	'portfolio.cashFlows.description': 'Insättningar och uttag över tid',
	'portfolio.cashFlows.netTotal': 'Netto (totalt)',
	'portfolio.cashFlows.netYtd': 'Netto (hittills i år)',
	'portfolio.cashFlows.noHistory': 'Ingen kapitalflödeshistorik tillgänglig än.',
	'portfolio.cashFlows.noTransactions': 'Inga insättningar eller uttag registrerade ännu.',
	'portfolio.cashFlows.portfolio': 'Portfölj',
	'portfolio.cashFlows.withdrawal': 'Uttag',
	'portfolio.create.bulkImport': 'Massimport',
	'portfolio.create.bulkImportDescription': 'Importera transaktioner från din mäklares CSV-export',
	'portfolio.create.create': 'Skapa portfölj',
	'portfolio.create.creating': 'Skapar...',
	'portfolio.create.currency': 'Visningsvaluta',
	'portfolio.create.currencyDescription': 'Valutan som används för portföljvärden och avkastning',
	'portfolio.create.currencyPlaceholder': 'Välj valuta',
	'portfolio.create.details': 'Detaljer',
	'portfolio.create.importMethod': 'Importmetod',
	'portfolio.create.methodQuestion': 'Hur vill du lägga till transaktioner i portföljen?',
	'portfolio.create.name': 'Portföljnamn',
	'portfolio.create.namePlaceholder': 't.ex. Huvudportfölj, Pensionssparande',
	'portfolio.create.startEmpty': 'Börja med tom portfölj',
	'portfolio.create.startEmptyDescription': 'Skapa en tom portfölj och lägg till transaktioner manuellt',
	'portfolio.create.title': 'Skapa ny portfölj',
	'portfolio.debug.cash': 'Likvida medel',
	'portfolio.debug.checksum': 'Kontrollsumma',
	'portfolio.debug.chosenClose': 'Vald stängningskurs',
	'portfolio.debug.date': 'Datum',
	'portfolio.debug.fxClose': 'Valutakurs vid stängning',
	'portfolio.debug.instrument': 'Instrument',
	'portfolio.debug.instrumentClose': 'Instrumentets stängningskurs',
	'portfolio.debug.instrumentId': 'Instrument {id}',
	'portfolio.debug.localClose': 'Lokal stängningskurs',
	'portfolio.debug.next': 'Nästa',
	'portfolio.debug.noPositions': 'Inga innehav med värde skilt från noll denna dag.',
	'portfolio.debug.page': 'Sida {current}/{total}',
	'portfolio.debug.positionValueId': 'Positionsvärdets ID',
	'portfolio.debug.previous': 'Föregående',
	'portfolio.debug.shares': 'Aktier',
	'portfolio.debug.showing': 'Visar {start}-{end} av {total}',
	'portfolio.debug.title': 'Felsökningsöversikt',
	'portfolio.debug.toggleHint': 'Aktivera i portföljinställningarna',
	'portfolio.debug.total': 'Totalt',
	'portfolio.debug.weight': 'Vikt',
	'portfolio.dividends.description': 'Översikt och senaste utdelningstransaktioner',
	'portfolio.dividends.dividend': 'Utdelning',
	'portfolio.dividends.noHistory': 'Ingen årssammanställning tillgänglig än.',
	'portfolio.dividends.noTransactions': 'Inga utdelningstransaktioner för aktiva innehav just nu.',
	'portfolio.dividends.title': 'Utdelningar',
	'portfolio.dividends.withholdingTax': 'Källskatt',
	'portfolio.empty': 'Du har inga portföljer ännu. Lägg till en ovanför.',
	'portfolio.history.allTime': 'Sedan start',
	'portfolio.history.cash': 'Likvida medel',
	'portfolio.history.cashFlows': 'Kapitalflöden',
	'portfolio.history.change': 'Förändring (SEK)',
	'portfolio.history.chartPeriod': 'Grafperiod',
	'portfolio.history.chartSettings': 'Grafinställningar',
	'portfolio.history.close': 'Stängningskurs',
	'portfolio.history.enableDebug': 'Aktivera felsökningstabellen i portföljinställningarna för hela dagstabellen.',
	'portfolio.history.excludedCashFlows': '{count} kapitalflöden i andra valutor eller utan datum ingår inte',
	'portfolio.history.holdings': 'Innehav (exkl. likvida medel)',
	'portfolio.history.instrument': 'Instrument',
	'portfolio.history.legacyRow': 'Äldre rad upptäckt. Bygg om portföljvärdena för att se hela felsökningsöversikten.',
	'portfolio.history.loadingHoldings': 'Läser in innehavsfördelning...',
	'portfolio.history.loadingShares': 'Läser in aktiehistorik...',
	'portfolio.history.max': 'Max',
	'portfolio.history.maximum': 'maximal',
	'portfolio.history.netDeposits': 'Nettoinsättningar (SEK)',
	'portfolio.history.netDepositsShort': 'Nettoinsättningar',
	'portfolio.history.noComposition': 'Ingen fördelningsdata tillgänglig för denna dag.',
	'portfolio.history.noShares': 'Ingen aktiehistorik för denna period.',
	'portfolio.history.performanceByPeriod': 'Utveckling per period',
	'portfolio.history.period': 'Period',
	'portfolio.history.rangeReturn': 'Avkastning för {period}',
	'portfolio.history.return': 'Avkastning',
	'portfolio.history.selectInstrument': 'Välj instrument',
	'portfolio.history.shares': 'Aktier',
	'portfolio.history.sharesCount': '{count} aktier',
	'portfolio.history.showPeriod': 'Visa perioden {period}',
	'portfolio.history.total': 'Totalt',
	'portfolio.history.unknownInstrument': 'Okänt instrument',
	'portfolio.history.value': 'Värde',
	'portfolio.navigate': 'Gå till portföljen "{name}"',
	'portfolio.news.empty': 'Inga nyheter för aktiva innehav just nu.',
	'portfolio.news.more': 'Visa fler nyheter',
	'portfolio.news.title': 'Nyheter',
	'portfolio.noSearchResults': 'Inga resultat hittades.',
	'portfolio.notFound': 'Portföljen hittades inte',
	'portfolio.notFoundDescription': 'Portföljen kunde inte läsas in för den aktuella sessionen.',
	'portfolio.openSettings': 'Öppna portföljinställningar',
	'portfolio.openTable': 'Öppna portföljtabellen',
	'portfolio.openTransactions': 'Öppna portföljtransaktioner',
	'portfolio.pagination.next': 'Nästa',
	'portfolio.pagination.page': 'Sida {current} av {total}',
	'portfolio.pagination.previous': 'Föregående',
	'portfolio.searchHelp': 'Osäker? Sök efter ett instrument',
	'portfolio.searchPlaceholder': 'Sök efter ett instrument...',
	'portfolio.searchResults': 'Sökresultat',
	'portfolio.selectAction': 'Välj',
	'portfolio.selectOption': 'Välj ett alternativ',
	'portfolio.shares': 'Aktier',
	'push.active': 'Aktiv',
	'push.allow': 'Tillåt',
	'push.blocked': 'Notiser är blockerade i den här webbläsaren. Aktivera dem i webbläsarinställningarna först.',
	'push.checking': 'Kontrollerar den här enheten...',
	'push.controller': 'Kontroller',
	'push.description':
		'Eqity kan skicka frivilliga pushnotiser om händelser som rör bolag och instrument i dina portföljer eller bevakningslistor.',
	'push.disabled': 'Inaktiverade',
	'push.enabled': 'Aktiverade',
	'push.endpoint': 'Slutpunkt',
	'push.inspectFailed': 'Det gick inte att kontrollera enheten.',
	'push.iosInstall':
		'På iPhone och iPad behöver du först lägga till Eqity på hemskärmen. Öppna sedan appen och aktivera pushnotiser här.',
	'push.lastEvent': 'Senaste pushhändelse',
	'push.localFailed': 'Det gick inte att visa en lokal notis.',
	'push.localRequested': 'Webbläsaren ombads visa en lokal notis via service worker.',
	'push.noActiveSubscriptions': 'Det finns inga aktiva prenumerationer för den här användaren.',
	'push.noneSeen': 'Ingen händelse i den här fliken',
	'push.noSubscription': 'Ingen webbläsarprenumeration',
	'push.notifications': 'Pushnotiser:',
	'push.notRegistered': 'Inte registrerad',
	'push.notSubscribed': 'Den här enheten prenumererar inte på notiser.',
	'push.permission': 'Behörighet',
	'push.prompt': 'Eqity vill skicka pushnotiser till dig. Tillåter du det?',
	'push.saveFailed': 'Det gick inte att spara pushprenumerationen.',
	'push.sendTest': 'Skicka testnotis',
	'push.serviceWorker': 'Service worker',
	'push.showLocalTest': 'Visa lokalt test',
	'push.subscribed': 'Den här enheten prenumererar på notiser.',
	'push.testFailed': 'Det gick inte att skicka en testnotis.',
	'push.testSent': 'Skickade {count, plural, one {# testnotis} other {# testnotiser}}.',
	'push.triggerBrowserSettings': 'Öppna webbläsarens inställningar för pushnotiser',
	'push.unavailable': 'Web Push är inte tillgängligt.',
	'push.unconfigured': 'Web Push är inte konfigurerat för den här miljön.',
	'push.unsupported': 'Den här webbläsaren stöder inte Web Push.',
	'push.updateFailed': 'Det gick inte att uppdatera pushnotiserna.',
	'push.waiting': 'Väntar på nästa sidladdning',
	'pushPoc.description': 'Testa pushnotiser utan att läsa in hela översikten.',
	'pushPoc.openSettings': 'Öppna notisinställningar',
	'pushPoc.title': 'Test av pushnotiser',
	'reports.availableFiles': '{count, plural, one {# tillgänglig fil} other {# tillgängliga filer}}',
	'reports.closeContent': 'Stäng {type}-innehåll',
	'reports.noContent': 'Inget innehåll valt',
	'reports.noneAvailable': 'Inga rapporter finns ännu för instrumentet.',
	'reports.openContent': 'Öppna {type}-innehåll',
	'reports.title': 'Rapporter',
	'reports.year': 'År',
	'settings.alternateRowColors': 'Växlande radfärger',
	'settings.alternateRowColorsDescription': 'Använd växlande bakgrundsfärger på tabellrader',
	'settings.autoHideTypes': 'Autoläge: Typer döljs när fördelningen bara innehåller likvida medel och en annan typ.',
	'settings.bulkImport': 'Massimport',
	'settings.bulkImportDescription': 'Importera transaktioner från CSV-exporter hos Avanza, Nordnet eller Degiro',
	'settings.cancel': 'Avbryt',
	'settings.close': 'Stäng inställningar',
	'settings.column.allTimePl': 'Resultat sedan start',
	'settings.column.averagePurchaseCost': 'Genomsnittligt anskaffningsvärde',
	'settings.column.currency': 'Valuta',
	'settings.column.general': 'Allmänt',
	'settings.column.instrument': 'Instrument',
	'settings.column.latestUpdate': 'Senaste uppdatering',
	'settings.column.local': 'Lokal',
	'settings.column.localAbsolute': 'Lokal absolut',
	'settings.column.localRelative': 'Lokal relativ',
	'settings.column.portfolioShare': 'Portföljandel',
	'settings.column.price': 'Pris',
	'settings.column.sek': '[SEK]',
	'settings.column.sekAbsolute': '[SEK] absolut',
	'settings.column.sekRelative': '[SEK] relativ',
	'settings.column.shares': 'Aktier',
	'settings.column.sizeAbsolute': 'Absolut storlek',
	'settings.column.ticker': 'Ticker',
	'settings.column.todaysPl': 'Dagens resultat',
	'settings.column.type': 'Typ',
	'settings.dangerZone': 'Riskzon',
	'settings.debugBreakdown': 'Felsökningstabell',
	'settings.debugBreakdownDescription': 'Visa eller dölj felsökningstabellen i portföljhistoriken',
	'settings.delete': 'Ta bort',
	'settings.deleteConfirmation':
		'Är du säker på att du vill ta bort "{name}"? Alla positioner, transaktioner och historiska data tas bort permanent. Åtgärden kan inte ångras.',
	'settings.deleteDescription': 'Ta bort portföljen och all dess data permanent',
	'settings.deletePortfolio': 'Ta bort portfölj',
	'settings.deleting': 'Tar bort...',
	'settings.display': 'Visning',
	'settings.displayCurrency': 'Visningsvaluta',
	'settings.displayCurrencyDescription': 'Valuta som används för att visa portföljvärden',
	'settings.displayDescription': 'Anpassa hur portföljtabellen ser ut',
	'settings.general': 'Allmänt',
	'settings.generalDescription': 'Grundläggande portföljinställningar',
	'settings.graph': 'Grafinställningar',
	'settings.graphDescription': 'Välj vilka fördelningsgrafer som visas',
	'settings.hideEmptyPositions': 'Dölj tomma positioner',
	'settings.hideEmptyPositionsDescription': 'Dölj positioner med noll aktier i tabellen',
	'settings.import': 'Importera',
	'settings.importDescription': 'Massimportera transaktioner från din mäklare',
	'settings.importTransactions': 'Importera transaktioner',
	'settings.portfolio.manageFor': 'Hantera inställningar för "{name}"',
	'settings.portfolio.title': 'Portföljinställningar',
	'settings.portfolioName': 'Portföljnamn',
	'settings.portfolioNamePlaceholder': 'Ange portföljnamn',
	'settings.saveChanges': 'Spara ändringar',
	'settings.saving': 'Sparar...',
	'settings.selectCurrency': 'Välj valuta',
	'settings.tableApplied': 'Ändringarna tillämpas direkt i portföljtabellen.',
	'settings.tableColumns': 'Tabellkolumner',
	'settings.tableColumnsDescription': 'Välj vilka kolumner som visas i portföljtabellen',
	'settings.visibilityApplied': 'Ändringar i grafer och tabeller tillämpas direkt under den aktuella sessionen.',
	'transactions.cash': 'Likvida medel',
	'transactions.cashCurrency': 'Kontovaluta',
	'transactions.date': 'Datum',
	'transactions.filteredCount': '{shown} av {total}',
	'transactions.fxRate': 'Valutakurs',
	'transactions.instrument': 'Instrument',
	'transactions.instrumentCurrency': 'Instrumentvaluta',
	'transactions.instrumentPrice': 'Instrumentpris',
	'transactions.next': 'Nästa',
	'transactions.page': 'Sida {current} av {total}',
	'transactions.previous': 'Föregående',
	'transactions.reset': 'Återställ',
	'transactions.rowsPerPage': 'Rader per sida',
	'transactions.search': 'Sök transaktioner',
	'transactions.searchPlaceholder': 'Sök transaktioner...',
	'transactions.shares': 'Aktier',
	'transactions.showing': 'Visar {shown} av {total}',
	'transactions.type': 'Typ',
	'transactions.value': 'Värde',
	'user.account.resetHint': 'Använd länken nedan för att återställa ditt lösenord:',
	'user.account.resetPassword': 'Återställ lösenord',
	'userNotifications.disableSound': 'Inaktivera notisljud',
	'userNotifications.enableSound': 'Aktivera notisljud',
	'userNotifications.languageTodo': 'Att göra: Språk och prenumerationer för notiser?',
	'userNotifications.open': 'Öppna notiser',
	'userNotifications.soundTitle': 'Aktivera eller inaktivera notisljud',
	'userNotifications.timeoutTodo': 'Att göra: Pausa notiser när användaren är inloggad?',
	'userSettings.accessibility': 'Tillgänglighet',
	'userSettings.account': 'Konto',
	'userSettings.advanced': 'Avancerat',
	'userSettings.appearance': 'Utseende',
	'userSettings.appSection': 'Appinställningar',
	'userSettings.navigateTo': 'Öppna inställningar för {destination}',
	'userSettings.notifications': 'Notiser',
	'userSettings.privacy': 'Integritet och säkerhet',
	'userSettings.profile': 'Profil',
	'userSettings.signOut': 'Logga ut',
	'userSettings.userSection': 'Användarinställningar',
	'watchlist.add': 'Lägg till ny bevakningslista',
	'watchlist.addInstrument': 'Lägg till instrument i bevakningslistan',
	'watchlist.cancelInstrument': 'Avbryt',
	'watchlist.closeNew': 'Stäng ny bevakningslista',
	'watchlist.closeSettings': 'Stäng inställningar',
	'watchlist.confirmInstrument': 'Lägg till instrument',
	'watchlist.confirmNew': 'Bekräfta ny bevakningslista',
	'watchlist.delete': 'Radera',
	'watchlist.deleteConfirm':
		'Är du säker på att du vill radera "{name}"? Alla tillhörande data tas bort permanent. Åtgärden kan inte ångras.',
	'watchlist.deleteTitle': 'Radera bevakningslista',
	'watchlist.empty': 'Du har inga bevakningslistor än. Lägg till en ovan.',
	'watchlist.instrumentCurrency': '{exchange} - {source}. Valuta: {currency}',
	'watchlist.name': 'Namn',
	'watchlist.nameRequired': 'Namn får inte vara tomt',
	'watchlist.navigate': 'Gå till bevakningslistan "{name}"',
	'watchlist.newName': 'Namn på ny bevakningslista',
	'watchlist.news': 'Nyheter',
	'watchlist.openNews': 'Öppna bevakningslistans nyheter',
	'watchlist.openOverview': 'Öppna bevakningslistans översikt',
	'watchlist.openSettings': 'Öppna bevakningslistans inställningar',
	'watchlist.overview': 'Översikt',
	'watchlist.removeInstrument': 'Ta bort instrument från bevakningslistan',
	'watchlist.save': 'Spara',
	'watchlist.settings': 'Inställningar för bevakningslista',
	...svServerErrorMessages,
};

export function getUiLanguage(locale: string): 'en' | 'sv' {
	return locale.toLowerCase().split(/[-_]/)[0] === 'sv' ? 'sv' : 'en';
}

export function getMessages(locale: string): Record<MessageId, string> {
	return getUiLanguage(locale) === 'sv' ? svMessages : enMessages;
}
